document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
  const slides = bar.querySelectorAll('[data-announcement-slide]');
  const prevBtn = bar.querySelector('[data-announcement-prev]');
  const nextBtn = bar.querySelector('[data-announcement-next]');
  const autoRotate = bar.dataset.autoRotate === 'true';
  const speed = parseInt(bar.dataset.speed || '5', 10) * 1000;

  if (slides.length <= 1) return;

  let currentIndex = 0;
  let timerId = null;

  function showSlide(index) {
    if (index >= slides.length) index = 0;
    if (index < 0) index = slides.length - 1;
    currentIndex = index;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === currentIndex));
  }

  function next() {
    showSlide(currentIndex + 1);
    resetTimer();
  }

  function prev() {
    showSlide(currentIndex - 1);
    resetTimer();
  }

  function resetTimer() {
    if (timerId) clearInterval(timerId);
    if (autoRotate) {
      timerId = setInterval(next, speed);
    }
  }

  prevBtn?.addEventListener('click', prev);
  nextBtn?.addEventListener('click', next);
  bar.addEventListener('mouseenter', () => { if (timerId) clearInterval(timerId); });
  bar.addEventListener('mouseleave', resetTimer);

  resetTimer();
});
